import axios from "axios";
import * as d3 from "d3";
import {
    colonAnnotation,
    fw_progressive_1way,
    fw_progressive_3way,
    inrFormatter,
    make_x_gridlines,
    make_y_gridlines,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, filterParam, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    var url2 = '/api/fetchDataWithParam/' + chart.data.vizSpecific4 + '/Any'

    console.log("Chart vizName called:", vizName)

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + 2 * chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    axios.post(url, filterParam).then(response => {
        let data = response.data
        console.log("response", data)


        // nest function allows to group the calculation per level of a factor
        var sumstat = d3.nest().key(d => {
            return d.dim1_name
        }).sortKeys(d3.ascending).entries(data)
        // Add X-axis for date and Y-axis
        var x1Scale = d3.scaleLinear().rangeRound([0, chart.width]).domain([d3.min(data, (d) => {
            return d.dim2_name
        }), d3.max(data, (d) => {
            return d.dim2_name
        })])
        var y1Scale = d3.scaleLinear().domain([0, d3.max(data, d => {
            return d.metric1
        })]).range([chart.height, 0])
        var y2Scale = d3.scaleLinear().domain([0, d3.max(data, d => {
            return d.metric2
        })]).range([chart.height, 0])

        svg.append('g')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(d3.axisBottom(x1Scale).ticks(20))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'end')
            .attr('dx', '-.8em')
            .attr('dy', '-.20em')
            .attr('transform', 'rotate(-60)')

        svg.append('text')
            .attr('x', (chart.width / 2))
            .attr('y', chart.height + chart.margin.bottom + 2 * chart.axisLabelDistance + 20)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('g')
            .call(d3.axisLeft(y1Scale).tickFormat(inrFormatter))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        svg.append("g")
            .attr("class", "y axis")
            .attr("transform", "translate(" + chart.width + " ,0)")
            .call(d3.axisRight(y2Scale).tickFormat(inrFormatter))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('x', 0 - (chart.height / 2))
            .attr('y', chart.width + chart.margin.right - 100)
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y2AxisDisplayName)
            .style('font-size', fontSize)

        if (gridflag == true) {
            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(make_x_gridlines(x1Scale)
                    .tickSize(-chart.height)
                    .tickFormat(""))

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat(""))
        }

        // color palette
        var res = sumstat.map(d => {
            return d.key
        }) // list of group main category
        var metric1ColorScale = d3.scaleOrdinal().domain(res).range(fw_progressive_1way)
        var metric2ColorScale = d3.scaleOrdinal().domain(res).range(fw_progressive_3way)
        // Draw the line
        svg.selectAll('.line')
            .data(sumstat)
            .enter()
            .append('path')
            .attr('fill', 'none')
            .attr('stroke', d => {
                return metric1ColorScale(d.key)
            })
            .attr('stroke-width', 3)
            .attr('d', (d) => {
                let line = d3.line()
                    .x(d => {
                        return x1Scale(d.dim2_name)
                    })
                    .y(d => {
                        return y1Scale(+d.metric1)
                    })

                return line(d.values)
            })
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        svg.selectAll('.line')
            .data(sumstat)
            .enter()
            .append('path')
            .attr('fill', 'none')
            .attr('class', 'plotdashed')
            .attr('stroke', d => {
                return metric2ColorScale(d.key)
            })
            .attr('stroke-width', 3)
            .attr('d', (d) => {
                let line = d3.line()
                    .x(d => {
                        return x1Scale(d.dim2_name)
                    })
                    .y(d => {
                        return y2Scale(+d.metric2)
                    })

                return line(d.values)
            })

        // Add the dots for the tooltip
        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
                   var y1tip = tooltip_class()

                   y1tip.attr('class', 'd3-tip'+divId.id).html((d)=> {
                         return chart.x1MetricTooltip+ colonAnnotation+ d.dim2_name+ "<br/>"+ chart.x2MetricTooltip
                         + colonAnnotation+ d.dim1_name+ "<br/>" +chart.y1MetricTooltip + colonAnnotation+ numberFormat(d.metric1)
                   })
                   svg.call(y1tip);

                   var y2tip = tooltip_class()
                   y2tip.attr('class', 'd3-tip'+divId.id).html((d)=> {
                          return chart.x1MetricTooltip+ colonAnnotation+ d.dim2_name+ "<br/>"+ chart.x2MetricTooltip
                          + colonAnnotation+ d.dim1_name+ "<br/>" + chart.y2MetricTooltip+ colonAnnotation+ numberFormat(d.metric2)
                   })
                   svg.call(y2tip);*/

        svg.selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("r", 5)
            .attr("cx", function (d) {
                return x1Scale(d.dim2_name);
            })
            .attr("cy", function (d) {
                return y1Scale(d.metric1);
            })
            .style("fill", d => {
                return metric1ColorScale(d.dim1_name)
            })
            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(chart.x1MetricTooltip + colonAnnotation + d.dim2_name + "<br/>" + chart.x2MetricTooltip
                    + colonAnnotation + d.dim1_name + "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric1))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            })
        //.on("mouseover", y1tip.show)
        //.on("mouseout", y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        svg.selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("r", 5)
            .attr("cx", function (d) {
                return x1Scale(d.dim2_name);
            })
            .attr("cy", function (d) {
                return y2Scale(d.metric2);
            })
            .style("fill", d => {
                return metric2ColorScale(d.dim1_name)
            })
            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(chart.x1MetricTooltip + colonAnnotation + d.dim2_name + "<br/>" + chart.x2MetricTooltip
                    + colonAnnotation + d.dim1_name + "<br/>" + chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric2))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            })
        //.on("mouseover", y2tip.show)
        //.on("mouseout", y2tip.hide)

        var y1legend = svg.append('g')
            .selectAll('g')
            .data(sumstat)
            .enter()
            .append('g')
            //.attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')
            .attr('transform', function (d, i) {                     // NEW
                //  var height = 0;          // NEW
                var horz = 250 * i; // NEW
                var vert = -10;       // NEW
                return 'translate(' + horz + ',' + vert + ')';        // NEW
            });

        y1legend
            //.append('rect')
            //      .attr('x',10)
            //      .attr('y', chart.height+ chart.margin.bottom - 60)
            //      .attr('width', 15)
            //      .attr('height', 15)
            .append('line')
            .attr("x1", 0)
            .attr("x2", 40)
            .attr("y1", chart.height + chart.margin.bottom - 45)
            .attr("y2", chart.height + chart.margin.bottom - 45)
            .attr("stroke-width", 3)
            // .attr("stroke","black")
            // .attr("stroke-opacity", "3")
            .attr("class", 'plotline')
            .attr('stroke', d => {
                return metric1ColorScale(d.key)
            })

        y1legend.append('text')
            .data(sumstat, (d) => {
                return d.key
            })
            .attr('x', 40)
            .attr('y', chart.height + chart.margin.bottom - 60)
            .attr('dy', '0.65em')
            .text((d) => {
                return chart.y1DataFieldName + d.key.substring(0, 7) + "~ "
            })
            .style('font-size', '25px')

        var y2legend = svg.append('g')
            .selectAll('g')
            .data(sumstat)
            .enter()
            .append('g')
            //.attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')
            .attr('transform', function (d, i) {
                //  var height = 0; // NEW
                var horz = 250 * i; // NEW
                var vert = 25; // NEW
                return 'translate(' + horz + ',' + vert + ')';  // NEW
            });

        y2legend
            .append('line')
            .attr("x1", 0)
            .attr("x2", 40)
            .attr("y1", chart.height + chart.margin.bottom - 45)
            .attr("y2", chart.height + chart.margin.bottom - 45)
            .attr("class", "plotdashed")
            .attr('stroke', d => {
                return metric2ColorScale(d.key)
            })

        y2legend.append('text')
            .data(sumstat, (d) => {
                return d.key
            })
            .attr('x', 40)
            .attr('y', chart.height + chart.margin.bottom - 60)
            .attr('dy', '0.75em')
            .text((d) => {
                return chart.y2DataFieldName + d.key.substring(0, 7) + "~ "
            })
            .style('font-size', '25px')

        axios.post(url2, {}).then(res2 => {
            let rectdata = res2.data.rowsData

            console.log("res2", rectdata)

            rectdata.forEach(function (d) {
                d.metric1 = +d.metric1;
                d.metric2 = +d.metric2
            })

            var bars = svg.selectAll("bar")
                .data(rectdata)
                .enter()
                .append('g')

            bars.append("rect")
                .attr("class", "bar")
                .attr("class", "dot-bar")
                //.attr("x", (d) =>{ return x1Scale(d.metric1) })
                //.attr("width", (d) =>{ return x1Scale(d.metric2) - x1Scale(d.metric1) })
                //.attr("height",chart.height-20)
                //.attr("y",20 )
                .attr("x", (d) => {
                    return d.metric1[0] == d.metric1[1] ? x1Scale(d.metric1) : x1Scale(d.metric1) + 40
                })
                .attr("width", (d) => {
                    return d.metric1[0] == d.metric1[1] ? x1Scale(d.metric2) - x1Scale(d.metric1) : x1Scale(d.metric2) - x1Scale(d.metric1) + 40
                })
                .attr("height", (d) => {
                    return d.metric1[0] == d.metric1[1] ? chart.height - 20 : chart.height - 60
                })
                .attr("y", (d) => {
                    return d.metric1[0] == d.metric1[1] ? 20 : 60
                })
                .style("fill", (d) => {
                    return d.dim2_name
                })
                .attr('stroke-dasharray', '5,2')
                .attr('stroke-width', '3')
                .attr('stroke', 'black')

            /* bars.append('text')
                      .style("font-size", "105px")
                      .style("fill","#808080")
                      .style('text-anchor','middle')
                      .attr("transform", function (d,i) {
                         var xText = x1Scale(d.metric1) + 100
                         var xText1= x1Scale(d.metric1) + 200
                         var yText = x1Scale(d.metric2) - x1Scale(d.metric1) -35
                         return xText[i]==xText[i+1]  ? "translate(" + xText1 + "," + yText + ") rotate(-90)" :"translate(" + xText + "," + yText + ") rotate(-90)";
                       })
                      .text(function(d) { return d.dim1_name})*/

            var y1legend = svg.append('g')
                .selectAll('g')
                .data(rectdata)
                .enter()
                .append('g')
                //.attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')
                .attr('transform', function (d, i) {
                    //var height = 0;          // NEW
                    var horz = 250 * i; // NEW
                    var vert = -10;       // NEW
                    return 'translate(' + horz + ',' + vert + ')';        // NEW
                });

            y1legend.append('rect')
                .attr('x', 10)
                .attr('y', -30)
                .attr('width', 15)
                .attr('height', 15)
                .attr('fill', d => {
                    return metric1ColorScale(d.dim2_name)
                })

            y1legend.append('text')
                .attr('x', 40)
                .attr('y', -15)
                //   .attr('dy', '-0.55em')
                .text((d) => {
                    return d.dim1_name
                })
                .style('font-size', '25px')
        })
    })
}
